/* app/js/src/components/mediaEditor/files-tab/upload/upload.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  border-radius: 4px;
  border: solid 1px #dde3e7;
  margin-right: 4px;
  position: relative;
  font-size: 12px;
  width: 70px;
  height: 26px;
}
:host.fail {
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
}
:host.fail ::ng-deep svg {
  width: 40px;
  height: 30px;
}
:host.fail .remove {
  right: 5px;
}
:host .progress-bar {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
:host icn-close-btn {
  position: absolute;
}
/*# sourceMappingURL=upload.component.css.map */
